<template>
  <div id="invoice-page">


    <vx-card id="invoice-container">

      <!-- INVOICE METADATA -->
      <div class="vx-row leading-loose p-base">
        <div class="vx-col w-1/2 mt-base">
          <img src="@/assets/images/logo/logo.png" alt="vuexy-logo">
        </div>
        <div class="vx-col w-1/2 text-right">
          <h1>Invoice</h1>
          <div class="invoice__invoice-detail mt-6">
            <h6>Order ID.</h6>
            <strong>{{ invoiceDetails.invoiceNo }}</strong>

            <h6 class="mt-4">INVOICE DATE</h6>
            <p>{{ invoiceDetails.invoiceDate }}</p>
          </div>
        </div>
        <div class="vx-col w-1/2 mt-12">
          <h5>Sanalogi Bilisim San. ve Tic. A.S</h5>
          <div class="invoice__recipient-info my-4">
            <p>{{ recipientDetails.fullName }}</p>
            <p>{{ recipientDetails.addressLine1 }}</p>
            <p>{{ recipientDetails.addressLine2 }}</p>
            <p>{{ recipientDetails.zipcode }}</p>
          </div>
          <div class="invoice__recipient-contact ">
            <p class="flex items-center">
              <feather-icon icon="MailIcon" svgClasses="h-4 w-4"></feather-icon>
              <span class="ml-2">{{ recipientDetails.mailId }}</span>
            </p>
            <p class="flex items-center">
              <feather-icon icon="PhoneIcon" svgClasses="h-4 w-4"></feather-icon>
              <span class="ml-2">{{ recipientDetails.mobile }}</span>
            </p>
          </div>
        </div>
        <div class="vx-col w-1/2 mt-base text-right mt-12">
          <h5>{{ companyDetails.name }} - {{companyDetails.username}}</h5>
          <div class="invoice__company-info my-4">
            <p>{{ companyDetails.addressLine1 }}</p>

          </div>
          <div class="invoice__company-contact">
            <p class="flex items-center justify-end">
              <feather-icon icon="MapPinIcon" svgClasses="h-4 w-4"></feather-icon>
              <span class="ml-2">{{ companyDetails.country }}</span>
            </p>
            <p class="flex items-center justify-end">
              <feather-icon icon="MailIcon" svgClasses="h-4 w-4"></feather-icon>
              <span class="ml-2">{{ companyDetails.mailId }}</span>
            </p>
            <p class="flex items-center justify-end">
              <feather-icon icon="PhoneIcon" svgClasses="h-4 w-4"></feather-icon>
              <span class="ml-2">{{ companyDetails.mobile }}</span>
            </p>
            <p class="flex items-center justify-end mt-5">
             <h6>Description</h6>
              <span class="ml-2"> {{ invoiceDetails.description }}</span>
            </p>
          </div>

        </div>
      </div>

      <!-- INVOICE CONTENT -->
      <div class="p-base">
        <!-- INVOICE TASKS TABLE -->
        <vs-table hoverFlat :data="invoiceData.tasks">
          <!-- HEADER -->
          <template slot="thead">
            <vs-th class="pointer-events-none">PRODUCT NAME</vs-th>
            <vs-th class="pointer-events-none">LICENSE PLATFORM</vs-th>
            <vs-th class="pointer-events-none">COUNT</vs-th>
            <vs-th class="pointer-events-none">END DATE</vs-th>
          </template>

          <!-- DATA -->
          <template slot-scope="{data}">
            <vs-tr v-for="(tr, index) in data" :key="index">
              <vs-td :data="data[index].productLiciences[0].productName">
                {{ data[index].productLiciences[0].productName }}</vs-td>
              <vs-td :data="data[index].liciencePlatform">{{ data[index].liciencePlatform }}</vs-td>
              <vs-td :data="data[index].productLiciences[0].count">{{ data[index].productLiciences[0].count }}</vs-td>
              <vs-td :data="data[index].productLiciences[0].endDate">{{ data[index].productLiciences[0].endDate }}
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
        <span class="total">TOTAL:&nbsp; <span class="font-semibold">{{invoiceData.total}} {{invoiceData.currencyCode}}
          </span></span>
        <p class="pt-5"> Payment Status: <span class="font-semibold">{{invoiceStatus}}</span> </p>

        <!-- INVOICE SUMMARY TABLE -->
        <!-- <vs-table hoverFlat class="w-1/2 ml-auto mt-4" :data="invoiceData">
                    <vs-tr>
                        <vs-th class="pointer-events-none">SUBTOTAL</vs-th>
                        <vs-td>{{ invoiceData.subtotal }} USD</vs-td>
                    </vs-tr>
                    <vs-tr>
                        <vs-th class="pointer-events-none">DISCOUNT ({{ invoiceData.discountPercentage }}%)</vs-th>
                        <vs-td>{{ invoiceData.discountedAmount }} USD</vs-td>
                    </vs-tr>
                    <vs-tr>
                        <vs-th class="pointer-events-none">TOTAL</vs-th>
                        <vs-td>{{ invoiceData.total }} USD</vs-td>
                    </vs-tr>
                </vs-table> -->
      </div>

      <!-- INVOICE FOOTER -->
      <div v-if="invoiceStatus == 'Pending' && invoiceData.paymentType == 'EFT'" class="invoice__footer text-right p-base">
        <p class="mb-4">When making the EFT transaction you should definitely write your ORDER ID in the description
          section. International money transfers can take up to 3 or 5 days.</p>
        <p>
          <span class="mr-8">Bank Name: <span class="font-semibold"> {{invoiceData.bankName}} </span></span>
          <span class="mr-8">Swift Code: <span class="font-semibold">{{invoiceData.swiftCode}}</span></span>
          <span>IBAN: <span class="font-semibold"> {{invoiceData.bankIban}} </span></span>
        </p>
      </div>

     
    </vx-card>


    <div class="flex flex-wrap items-center justify-end my-5">

      <div class="flex">
        <vs-button class="mb-base mr-3" icon-pack="feather" icon="icon icon-file" @click="printInvoice">Print
        </vs-button>
        <vs-button v-if="invoiceData.paymentType == 'CreditCard' && invoiceStatus == 'Unpaid'" class="mb-base mr-3"
          color="success" icon-pack="feather" icon="icon icon-credit-card" @click="showPaymentForm">Complete Payment
        </vs-button>
        <vs-button v-if="invoiceStatus == 'Completed'" class="mb-base mr-3"
          color="success" icon-pack="feather" icon="icon icon-git-commit" @click="showPaymentForm"> Extend this products
        </vs-button>
        
      </div>
    </div>


    <vx-card class="mt-5" v-if="showForm">


      <vs-tabs v-model="activeTab"  alignment="fixed">
        <vs-tab label="Credit Card">
          <vs-col vs-w="12">

            <h5 class="text-left mt-10 mb-3">Enter your credit card detail</h5>
          </vs-col>

          <!-- <form data-vv-scope="step-5" action="https://entegrasyon.asseco-see.com.tr/fim/est3Dgate" method="post"> -->
          <form data-vv-scope="step-5" :action="authConfig.bankURL" method="post">
            <div class="vx-row mb-2">
              <div class="vx-col w-full">
                <vs-input class="w-full" v-validate="'required|min:16'" data-vv-validate-on="blur" type="number"
                  name="pan" label-placeholder="Card Number" :value="modelData.pan" v-model="modelData.pan" />
              </div>
            </div>
            <div class="vx-row mb-2">
              <div class="vx-col w-full">Expire Date</div>
              
              <div class="vx-col">
                <vs-input class="w-full" v-validate="'required|min:2'" type="number"
                  name="Ecom_Payment_Card_ExpDate_Month" label-placeholder="Month"
                  :value="modelData.Ecom_Payment_Card_ExpDate_Month"
                  v-model="modelData.Ecom_Payment_Card_ExpDate_Month" />
              </div>
              <div class="vx-col">
                <vs-input class="w-full" v-validate="'required|min:2'" type="number" name="Ecom_Payment_Card_ExpDate_Year"
                  label-placeholder="Year" :value="modelData.Ecom_Payment_Card_ExpDate_Year"
                  v-model="modelData.Ecom_Payment_Card_ExpDate_Year" />
              </div>
            </div>
            <div class="vx-row mb-6">
              <div class="vx-col w-full">
                <vs-input class="w-full" v-validate="'required|min:3|max:3'" label-placeholder="Security Code" name="cv2"
                  placeholder="Security Code" :value="modelData.cv2" v-model="modelData.cv2" />
              </div>
            </div>
            <div class="vx-row mb-2">
              <div class="vx-col w-full">
                <vs-checkbox disabled v-model="securePayment">3d Secure payment method. (only Available for Turkish Credit Cards) </vs-checkbox>

              </div>
            </div>

            <input type="hidden" name="clientid" v-model="modelData.clientid" />
            <input type="hidden" name="amount" v-model="modelData.amount" />
            <input type="hidden" name="oid" v-model="modelData.oid" />
            <input type="hidden" name="okUrl" v-model="modelData.okUrl" />
            <input type="hidden" name="failUrl" v-model="modelData.failUrl" />
            <input type="hidden" name="rnd" v-model="modelData.rnd" />
            <input type="hidden" name="hash" v-model="modelData.hash" />
            <input type="hidden" name="callbackurl" value="" />
            <input type="hidden" name="callbackCall" value="false" />
            <input type="hidden" name="storetype" v-model="modelData.storetype" />
            <input type="hidden" name="lang" v-model="modelData.lang" />
            <input type="hidden" name="islemTipi" v-model="modelData.islemTipi" />
            <input type="hidden" name="currency" v-model="modelData.currency" />

            <button type="submit" v-show="false" id="pos-btn" value="submit">test post</button>
            <vs-button :disabled="!validateForm" class="mb-base mr-3 ml-auto" icon-pack="feather"
              icon="icon icon-credit-card"  @click="repay">Pay</vs-button>
          </form>
        </vs-tab>


        <vs-tab label="Bank Transfer">
          <div class="vx-row">

            <div class="vx-col lg:w-2/3 mt-10">
              <h5 class="text-left mb-3">Select your prefered bank</h5>
              <!-- <v-select data-vv-validate-on="blur" placeholder="Select one of the bank accounts" name="platform_name"
                    v-model="selectedBank" v-validate="'required'" label="Bank Name" :options="bankOptions" class="mb-5"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'" /> -->


              <form>
                <v-select v-model="selectedBank" name="bank.name" placeholder="Select one of the bank accounts"
                  v-validate="'required'" class="mb-5" data-vv-validate-on="blur" @input="changeBank"
                  :options="bankOptions.filter(x=> x.accountType === 2).filter(y => y.isActive == true)" label="bankText">
                  <template slot="option" slot-scope="option">
                    <div class="py-2 d-flex">
                      <img height="20px" class="mr-2" :src="`${authConfig.uploadPath}${option.bank.imageUrl}`" />
                      <span> {{option.ibanNo}} - {{option.accountOwner}} - {{option.currency}} </span>
                    </div>

                  </template>
                </v-select>


                <span class="text-danger">{{platformError}}</span>

                <vs-textarea label="Type a description for your Order" v-model="eftDescription" />

                <div class="d-flex"><vs-button :disabled="!validateForm2" class="mb-base mr-3 ml-auto"  @click="repay">Submit</vs-button></div>

                <span class="text-danger">{{platformError}}</span>
              </form>
            </div>

            <div class="vx-col lg:w-1/3 mt-10" style="min-height: 300px">
              <div v-if="showTimeline">
                <vx-card title="Don't Forget" noShadow>
                  <vx-timeline :data="timelineData"></vx-timeline>
                </vx-card>
              </div>
            </div>

          </div>
        </vs-tab>
      </vs-tabs>


    </vx-card>


  </div>
</template>

<script>
import vSelect from 'vue-select'
import VxTimeline from '@/components/timeline/VxTimeline.vue'
import authConfig from '@/../auth_config.json'


export default {
  components: {

    'v-select': vSelect,
    VxTimeline
  },
  created () {
    this.getOrder()
    this.getBankOptions()
  },
  watch: {
    activeTab (val) {
      this.modelData.pan = '',
      this.modelData.Ecom_Payment_Card_ExpDate_Year = '',
      this.modelData.Ecom_Payment_Card_ExpDate_Month = '',
      this.modelData.cv2 = '',
      this.securePayment = true
    }

  },
  data () {
    return {
      authConfig,
      timelineData: [
        {
          color: 'primary',
          icon: 'PlusIcon',
          title: 'Company Name',
          desc: 'Sanalogi Bilisim San. ve Tic. A.S'
        },
        {
          color: 'warning',
          icon: 'AlertCircleIcon',
          title: 'Bank Information',
          desc: `Use the Swift Code: ${this.selectedBank && this.selectedBank.bank.swiftCode ? this.selectedBank.bank.swiftCode : ''}
             (out of Turkish banks) and IBAN:${this.selectedBank && this.selectedBank.bank.name ? this.selectedBank.bank.name : ''}.`
        },
        {
          color: 'success',
          icon: 'CheckIcon',
          title: 'EFT transaction',
          desc: 'You should definitely write your ORDER ID in the description section.',
          time: 'International money transfers can take up to 3 or 5 days'
        }
      ],
      platformError:'',
      showTimeline: false,
      mailTo: '',
      invoiceStatus: '',
      companyDetails: {
        name: '...',
        username: '...',
        addressLine1: '9 N. Sherwood Court',
        addressLine2: 'Elyria, OH',
        country: '...',
        mailId: 'hello@pixinvent.net',
        mobile: '+91 999 999 9999'
      },
      recipientDetails: {
        fullName: 'Y.T.U. Ikitelli Teknopark',
        addressLine1: 'No:1 F:2/16 ',
        addressLine2: 'Basaksehir Istanbul TR',
        zipcode: '34250',
        mailId: 'sales@nfcread.com',
        mobile: '+90 850 557 7654',
       
      },
      invoiceDetails: {
        invoiceNo: '001/2019',
        invoiceDate: 'Mon Dec 10 2018 07:46:00 GMT+0000 (GMT)',
         description:''
      },
      invoiceData: {
        tasks: [
          {
            id: 1,
            productLiciences: [
              {
                productName: '...',
                count: '',
                endDate: '...'
              }
            ],
            liciencePlatform: 60
          }
        ],
        subtotal: 114000,
        discountPercentage: 5,
        discountedAmount: 5700,
        total: 108300,
        paymentType: '',
        bankName:'',
        bankIban:'',
        swiftCode:''
      },
      modelData: {
        pan: '',
        cv2: '',
        Ecom_Payment_Card_ExpDate_Year: '',
        Ecom_Payment_Card_ExpDate_Month: '',
        cardType: null,
        clientid: null,
        islemtipi: 'Auth',
        amount: null,
        oid: null,
        okUrl: null,
        failUrl: null,
        rnd: null,
        hash: null,
        storetype: null,
        lang: 'tr',
        currency: 949
      },
      activeTab: 0,
      paymentType:'',
      securePayment: true,
      showForm: false,
      bankOptions:[],
      selectedBank:'',
      eftDescription:''


    }
  },
  computed: {
    validateForm () {
      return !this.errors.any() && this.pan !== '' && this.modelData.Ecom_Payment_Card_ExpDate_Year !== '' && this
        .modelData.Ecom_Payment_Card_ExpDate_Month !== '' && this.modelData.cv2 !== ''
    },
    validateForm2 () {
      return  this.eftDescription !== '' && this.selectedBank !== ''
    }

  },
  methods: {
    changeBank () {
      this.timelineData[1].desc = `Use the Swift Code: ${this.selectedBank.bank.swiftCode} (out of Turkish banks) and IBAN:${this.selectedBank.ibanNo}.`
      this.showTimeline = true
    },
    getBankOptions () {
      this.$store.dispatch('bank/getAllAccounts')
        .then((response) => {
          this.bankOptions = response.data
        })
        .catch(error => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },
    getOrder () {
      this.$store.dispatch('order/getOrder', this.$route.params.orderId)
        .then((response) => {
          this.invoiceStatus = response.data.orderState
          this.invoiceDetails.invoiceNo = response.data.orderNumber
          this.invoiceDetails.invoiceDate = response.data.orderDate
          this.invoiceDetails.description = response.data.description
          this.companyDetails.mobile = response.data.phone
          this.companyDetails.mailId = response.data.email
          this.companyDetails.addressLine1 = response.data.address
          this.companyDetails.country = response.data.country
          this.companyDetails.name = response.data.companyName
          this.companyDetails.username = response.data.username
          this.invoiceData.tasks = response.data.orderItems
          this.invoiceData.total = response.data.price
          this.invoiceData.currencyCode = response.data.currencyCode
          this.invoiceData.paymentType = response.data.paymentType
          this.invoiceData.bankName = response.data.bankName
          this.invoiceData.bankIban = response.data.bankIban
          this.invoiceData.swiftCode = response.data.swiftCode

          // hide form when repay occurs
          this.showForm = false
        })
        .catch(error => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },
    repay () {
      this.$vs.loading()
      const payload = new FormData()
      payload.append('description', this.eftDescription)
      payload.append('OrderId', this.invoiceDetails.invoiceNo)
      payload.append('PaymentType', parseInt(this.activeTab) + 1)
      payload.append('accountId', this.selectedBank.id)


      this.$store.dispatch('product/repay', payload)
        .then((response) => {
          this.$vs.loading.close()
          if (response.data.result) {
            this.$vs.notify({
              title: 'Successfull',
              text: response.message,
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'success'
            })
            this.modelData.amount = response.data.data.amount
            this.modelData.oid = response.data.data.oid
            this.modelData.currency = response.data.data.currency
            this.modelData.failUrl = response.data.data.failUrl
            this.modelData.okUrl = response.data.data.okUrl
            this.modelData.rnd = response.data.data.rnd
            this.modelData.hash = response.data.data.hash
            this.modelData.islemTipi = response.data.data.islemTipi
            this.modelData.clientid = response.data.data.shopCode
            this.modelData.storetype = response.data.data.storetype
            this.modelData.storeKey = response.data.data.storeKey
            //
            if (response.data.data.isEFT) {
              this.$vs.notify({
                time: 4000,
                title: response.data.message,
                text: 'Successfull',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'success'
              })
              this.getOrder()

            } else {
              // Else post bank we are redirecting payment screen
              this.$vs.loading.close()
              this.$vs.notify({
                text: 'Congratulations.We are redirecting you payment secreen',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
                color: 'success'
              })

              const button = document.getElementById('pos-btn')

              setTimeout(() => {
                button.click()
              }, 3000)

            }
          }


        })
        .catch(error => {
          this.$vs.loading.close()
          this.$vs.notify({
            title: 'Error',
            text: error.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })


    },
    printInvoice () {
      window.print()
    },
    showPaymentForm () {
      this.showForm = true
    }
  },
  mounted () {
    this.$emit('setAppClasses', 'invoice-page')
  }
}
</script>

<style lang="scss">
  .total {
    text-align: right;
    justify-content: flex-end;
    font-size: 1.125rem;
    padding-bottom: 4px;
    float: right;
    background: #f3f3f3;
    padding: 4px 8px;
  }

  @media print {
    .invoice-page {
      * {
        visibility: hidden;
      }

      #content-area {
        margin: 0 !important;
      }

      .vs-con-table {
        .vs-con-tbody {
          overflow: hidden !important;
        }
      }

      #invoice-container,
      #invoice-container * {
        visibility: visible;
      }

      #invoice-container {
        position: absolute;
        left: 0;
        top: 0;
        box-shadow: none;
      }
    }
  }

  @page {
    size: auto;
  }
</style>